import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiArrowRight } from "react-icons/fi";
import Loading from '../feedback/Loading';
import blogServices from '../../services/BlogServices';
import Empty from '../feedback/Empty';

function BlogList() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [nextPage, setNextPage] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const fetchPosts = (page = 1) => {
        setLoading(true);
        blogServices.listPosts(`?page=${page}`)
            .then(res => {
                setPosts(res.data.results);
                setNextPage(res.data.next);
                setCurrentPage(page);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPosts(1);
    }, []);

    const getSnippet = (html, maxLength = 120) => {
        const text = html.replace(/<[^>]*>/g, '');
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    if (loading && posts.length === 0) {
        return (
            <Loading />
        );
    }

    return (
        <section id="posts" className="max-w-7xl mx-auto px-6 md:px-12 py-24">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {posts.map(post => (
                    <Link
                        to={`/blog/post/${post.id}`}
                        key={post.id}
                        className="group bg-base-100 border border-zinc-200 rounded-lg overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:shadow-zinc-200/50 hover:border-primary/30 transition-all duration-300"
                    >
                        <div className="aspect-video overflow-hidden bg-zinc-100">
                            {post.image ? (
                                <img
                                    src={post.image}
                                    alt={post.title}
                                    className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105"
                                />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center text-zinc-400">
                                    No image
                                </div>
                            )}
                        </div>
                        <div className="p-6">
                            <h3 className="text-xl font-bold text-base-content mb-3 group-hover:text-primary transition-colors line-clamp-2">
                                {post.title}
                            </h3>
                            <p className="text-sm text-zinc-600 leading-relaxed line-clamp-2 mb-4">
                                {getSnippet(post.content)}
                            </p>
                            <div className="flex items-center justify-between pt-4 border-t border-zinc-100">
                                <span className="text-xs text-zinc-500 flex items-center gap-1">
                                    <FiCalendar className="w-3 h-3" />
                                    {new Date(post.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                </span>
                                <span className="text-xs font-bold uppercase tracking-widest text-primary flex items-center gap-1 group-hover:gap-2 transition-all">
                                    Read <FiArrowRight className="w-3 h-3" />
                                </span>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

            {nextPage && (
                <div className="mt-12 flex justify-center">
                    <button
                        onClick={() => fetchPosts(currentPage + 1)}
                        className="inline-flex items-center gap-2 border border-zinc-300 text-base-content px-6 py-3 text-xs font-bold uppercase tracking-widest rounded hover:bg-base-200 transition-all"
                    >
                        Load More Posts
                        <FiArrowRight className="w-4 h-4" />
                    </button>
                </div>
            )}
            {posts.length === 0 && (
                <Empty  objectName={"Posts"}/>
            )}
        </section>
    );
}

export default BlogList;